module.exports = __webpack_public_path__ + "static/media/italic.376d09c2.svg";